/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import * as r3 from '@leandredev/r3-ng-lib';

import { ApiHelper, ConfService } from '@leandredev/common_ng';

import { DataService } from 'src/app/webservices/dataService.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { interfaces } from '@leandredev/r3-common-lib';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  public homeService: r3.service.Home;

  constructor(private runTimeDataService: DataService, private confService: ConfService) {
    this.homeService = this.runTimeDataService.homeService;
  }

  public contact(contactRequest: interfaces.IContactRequest): Observable<interfaces.IContactResponse> {
    return this.homeService.contact(contactRequest, {}).pipe(ApiHelper.resultToObjWEmptyError('Erreur d\'envoie du message'));
  }

  public contactPartner(contactRequest: interfaces.IContactRequest): Observable<interfaces.IContactResponse> {
    return this.homeService.contactPartner(contactRequest, {}).pipe(ApiHelper.resultToObjWEmptyError('Erreur d\'envoie du message'));
  }
}
